import { render, staticRenderFns } from "./videomode.vue?vue&type=template&id=6173f019&scoped=true"
import script from "./videomode.vue?vue&type=script&lang=ts"
export * from "./videomode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6173f019",
  null
  
)

export default component.exports